import theme from "@/styles/theme";
import { Paper, Tooltip, type TooltipProps } from "@mui/material";

type Props = TooltipProps & {
	offsetX: number;
	offsetY: number;
};

export function CustomTooltip({
	title,
	children,
	offsetX,
	offsetY,
	placement,
	sx,
	...rest
}: Props) {
	return (
		<Tooltip
			title={title}
			placement={placement}
			slotProps={{
				tooltip: {
					component: Paper,
					sx: {
						bgcolor: theme.palette.background.paper,
						padding: 1.25,
						margin: 0,
						...sx,
					},
				},
				popper: {
					modifiers: [
						{
							name: "offset",
							options: {
								offset: [offsetX, offsetY],
							},
						},
					],
				},
			}}
			{...rest}
		>
			{children}
		</Tooltip>
	);
}
